(function () {
  if (window.__bProductInfoButtonsInit) return;
  window.__bProductInfoButtonsInit = true;

  var TARGET_BG = '#121212';
  var TARGET_COLOR = '#ffffff';
  var HOVER_BG = '#5433eb';
  var STYLE_ID = 'b-product-info-shop-pay-style';
  var HOST_SELECTOR = 'shopify-accelerated-checkout, shop-pay-wallet-button';
  var BUTTON_SELECTOR = [
    'button',
    '[role="button"]',
    '.gravity-button',
    '.wallet-button',
    '.shop-pay-button',
    '.shop-pay-button__button',
    '.shopify-payment-button__button'
  ].join(',');

  function styleButton(button) {
    button.style.setProperty('height', '48px', 'important');
    button.style.setProperty('min-height', '48px', 'important');
    button.style.setProperty('border-radius', '40px', 'important');
    button.style.setProperty('width', '100%', 'important');
    button.style.setProperty('background', TARGET_BG, 'important');
    button.style.setProperty('background-color', TARGET_BG, 'important');
    button.style.setProperty('color', TARGET_COLOR, 'important');
  }

  function injectStyle(root) {
    if (!root || root.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      ':host {',
      '  width: 100% !important;',
      '  --shopify-accelerated-checkout-button-block-size: 48px !important;',
      '  --shopify-accelerated-checkout-button-border-radius: 40px !important;',
      '  --shopify-accelerated-checkout-button-background: ' + TARGET_BG + ' !important;',
      '  --shop-pay-button-background: ' + TARGET_BG + ' !important;',
      '}',
      BUTTON_SELECTOR + ' {',
      '  width: 100% !important;',
      '  height: 48px !important;',
      '  min-height: 48px !important;',
      '  border-radius: 40px !important;',
      '  background: ' + TARGET_BG + ' !important;',
      '  background-color: ' + TARGET_BG + ' !important;',
      '  color: ' + TARGET_COLOR + ' !important;',
      '}',
      BUTTON_SELECTOR + ':hover {',
      '  background: ' + HOVER_BG + ' !important;',
      '  background-color: ' + HOVER_BG + ' !important;',
      '}'
    ].join('\n');

    root.appendChild(style);
  }

  function processRoot(root) {
    if (!root) return;

    injectStyle(root);
    root.querySelectorAll(BUTTON_SELECTOR).forEach(styleButton);
    root.querySelectorAll('*').forEach(function (node) {
      if (node.shadowRoot) processRoot(node.shadowRoot);
    });
  }

  function processHost(host) {
    host.style.setProperty('width', '100%', 'important');
    host.style.setProperty('--shopify-accelerated-checkout-button-background', TARGET_BG, 'important');
    host.style.setProperty('--shop-pay-button-background', TARGET_BG, 'important');

    if (host.shadowRoot) {
      processRoot(host.shadowRoot);
    }
  }

  function processAll() {
    document.querySelectorAll(HOST_SELECTOR).forEach(processHost);
  }

  function observeHost(host) {
    if (!host || host.dataset.productInfoButtonsObserved === 'true') return;
    host.dataset.productInfoButtonsObserved = 'true';

    var observer = new MutationObserver(function () {
      processHost(host);
    });

    observer.observe(host, { childList: true, subtree: true });

    if (host.shadowRoot) {
      var shadowObserver = new MutationObserver(function () {
        processRoot(host.shadowRoot);
      });
      shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
    }
  }

  function init() {
    processAll();
    document.querySelectorAll(HOST_SELECTOR).forEach(observeHost);
  }

  function scheduleInit() {
    init();
    window.setTimeout(init, 100);
    window.setTimeout(init, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  ['shopify-accelerated-checkout', 'shop-pay-wallet-button'].forEach(function (tagName) {
    if (customElements.get(tagName)) {
      scheduleInit();
      return;
    }

    customElements.whenDefined(tagName).then(scheduleInit).catch(function () {});
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.quick-add__button, quick-add-component')) {
      scheduleInit();
    }
  }, true);

  var outer = new MutationObserver(scheduleInit);
  outer.observe(document.documentElement, { childList: true, subtree: true });
})();
